import { openWindow } from '@umu/umu-dom';
import './searchInputForContentOfUseNormal.scss';
import React, { useEffect, useState } from 'react';
import { cleanHistory, searchHistory } from '@umu/umu-api';
import { IAppSearchData, IAppRecommendData } from '@umu/umu-types';
import { INPUT_CLICK_STATUS } from '@umu/umu-search/src/searchInputForContent/common/interface';
import {
    getUseRecommandData,
    getSearchData,
    paramsData,
} from '@umu/umu-search/src/searchInputForContent/common/service';
import {
    defaultRecommendData,
    getFilterParams,
    getParametersByObj,
    headerTypeData,
} from '@umu/umu-search/src/searchInputForContent/common/dataflow';
import SearchInputForContentBase from '@umu/umu-search/src/searchInputForContent/common/components/searchInputForContentBase/searchInputForContentBase';
import cloneDeep from 'lodash/cloneDeep';

type SearchInputForContentOfUseNormalProps = {
    eid: string;
    sort: string;
    keyWords: string;
    headerType: number;
    categoryId: string;
    goUseHome: () => void;
};

function SearchInputForContentOfUseNormal(props: SearchInputForContentOfUseNormalProps) {
    const { eid, sort, keyWords, headerType, categoryId, goUseHome } = props;
    const [recommandData, setRecommandData] = useState<IAppRecommendData>(defaultRecommendData);

    const buildSearchUrl = (param: { [x: string]: string | number }) => {
        const hrefConnect = getParametersByObj(
            getFilterParams({
                ...param,
            }),
        );
        const urls = hrefConnect !== '' ? `?${hrefConnect}` : '';
        return `/search/result/${urls}`;
    };

    const searchCallback = (keyWords: string) => {
        const url = buildSearchUrl({
            eid,
            sort,
            ums: 1,
            keyWords,
            categoryId,
            isResult: 'show',
            headerType: headerTypeData.use,
        });
        openWindow(url, '_blank');
    };

    const cleanCallback = async () => {
        await cleanHistory();
        const historyData = await searchHistory(paramsData);
        setRecommandData(Object.assign(recommandData || defaultRecommendData, { historySearch: historyData.list }));
    };

    const clickCallback = (data: IAppSearchData, key: INPUT_CLICK_STATUS) => {
        const urls = (data.extends && data.extends.share_url) || data.group_url || data.share_url || '';
        switch (key) {
            case INPUT_CLICK_STATUS.BUBBLE:
                searchCallback(data.keyword || '');
                break;
            case INPUT_CLICK_STATUS.POPULAR:
            case INPUT_CLICK_STATUS.COURSE:
            case INPUT_CLICK_STATUS.LENOVO:
                openWindow(urls, '_blank');
                break;
            case INPUT_CLICK_STATUS.MOUSEDOWN:
                break;
            default:
                break;
        }
    };

    const searchInputCallback = async (key: string) => {
        if (key === '') {
            const newRecommendData = await getUseRecommandData();
            setRecommandData(newRecommendData);
        } else {
            const LenovoCourse = await getSearchData(key);
            setRecommandData(cloneDeep({ ...(recommandData || defaultRecommendData), LenovoCourse }));
        }
    };

    const searchInputClearCallback = () => {
        if (Number(headerType) === headerTypeData.use) {
            goUseHome?.();
        }
    };

    const searchInputOnChange = (key: string) => {
        if (key === '' && Number(headerType) === headerTypeData.use) {
            goUseHome?.();
        }
    };

    const initRecommandData = async () => {
        const newRecommendData = await getUseRecommandData();
        setRecommandData(newRecommendData);
    };

    useEffect(() => {
        initRecommandData();
    }, []);

    return (
        <div className="search-input-for-content search-input-for-content__use-normal">
            <SearchInputForContentBase
                inputType="useCommon"
                searchKeyword={keyWords}
                showFloatingLayer={true}
                defaultFloatValue={false}
                isHiddenSearchIcon={true}
                recommendData={recommandData}
                cleanCallback={cleanCallback}
                clickCallback={clickCallback}
                onChange={searchInputOnChange}
                searchCallback={searchCallback}
                searchInputCallback={searchInputCallback}
                searchInputClearCallback={searchInputClearCallback}
            />
        </div>
    );
}

export default SearchInputForContentOfUseNormal;
